import { IMAGES } from "./constants";

// Conteúdo administrável do site HB Solar / HB Charger.
// Campos com valor null são exibidos como "Sob consulta" / "Em atualização"
// até que a empresa envie os dados definitivos.

export const COMPANY = {
  marcaSolar: "HB Solar",
  marcaCharger: "HB Charger",
  dominio: "hbsolarenergia.com.br",
  telefone: "(73) 98806-8321",
  whatsapp: "(73) 98806-8321",
  email: "hbsolar@outlook.com.br",
  cnpj: "41.427.100/0001-86",
  endereco: "Jequié — Bahia",
  regioes: "Bahia — demais regiões sob consulta",
};

export const EV_IMAGES = {
  hero: "https://images.pexels.com/photos/33508507/pexels-photo-33508507.jpeg?auto=compress&cs=tinysrgb&w=1600",
  urbano: "https://images.pexels.com/photos/33508505/pexels-photo-33508505.jpeg?auto=compress&cs=tinysrgb&w=1600",
  solarRecarga: "https://images.pexels.com/photos/9800030/pexels-photo-9800030.jpeg?auto=compress&cs=tinysrgb&w=1600",
  carregador: "https://images.pexels.com/photos/35736782/pexels-photo-35736782.jpeg?auto=compress&cs=tinysrgb&w=1600",
  eletroposto: "https://images.pexels.com/photos/33083244/pexels-photo-33083244.jpeg?auto=compress&cs=tinysrgb&w=1600",
};

export const SOLAR_STATS = {
  projetos: "580+",
  economia: "até 95%",
  garantia: "25 anos",
};

export const CHARGERS = [
  {
    id: "hb-charger-01",
    nome: "HB Solar Charger 01",
    linha: "Carregador rápido DC",
    foto: "/hb-charger-01.png",
    potencia: "60–480 kW",
    conectores: "2 × CCS2",
    voltagem: "380 V ±10% AC",
    tensao: "150–1000 V DC",
    comunicacao: "OCPP 1.6 (OCPP 2.0 opcional)",
    potenciaConfiguravel: "Sim — conforme a infraestrutura elétrica do local",
    caracteristicas: [
      "Recarga rápida DC com 2 conectores CCS2",
      "Corrente de 250 A (300 A opcional)",
      "Interface de operação intuitiva com medidor de energia em tempo real",
      "Leitor de cartão RFID para autenticação de usuários",
      "Monitoramento remoto via OCPP",
      "Proteção IP54 contra poeira e água",
    ],
    resumo: "Estação de recarga rápida DC de 60 a 480 kW, ideal para postos, empresas, shoppings e frotas.",
  },
  {
    id: "hb-charger-02",
    nome: "HB Solar Charger 02",
    linha: "Carregador rápido DC",
    foto: "/hb-charger-03.png",
    potencia: "60–480 kW",
    conectores: "2 × CCS2",
    voltagem: "380 V ±10% AC",
    tensao: "150–1000 V DC",
    comunicacao: "OCPP 1.6 (OCPP 2.0 opcional)",
    potenciaConfiguravel: "Sim — conforme a infraestrutura elétrica do local",
    caracteristicas: [
      "Recarga rápida DC com 2 conectores CCS2",
      "Corrente de 250 A (300 A opcional)",
      "Interface de operação intuitiva com medidor de energia em tempo real",
      "Leitor de cartão RFID para autenticação de usuários",
      "Monitoramento remoto via OCPP",
      "Proteção IP54 contra poeira e água",
    ],
    resumo: "Estação de recarga rápida DC de 60 a 480 kW, ideal para postos, empresas, shoppings e frotas.",
  },
  {
    id: "hb-charger-03",
    nome: "HB Solar Charger 03",
    linha: "Carregador rápido DC",
    foto: "/hb-charger-02.png",
    potencia: "60–480 kW",
    conectores: "2 × CCS2",
    voltagem: "380 V ±10% AC",
    tensao: "150–1000 V DC",
    comunicacao: "OCPP 1.6 (OCPP 2.0 opcional)",
    potenciaConfiguravel: "Sim — conforme a infraestrutura elétrica do local",
    caracteristicas: [
      "Recarga rápida DC com 2 conectores CCS2",
      "Corrente de 250 A (300 A opcional)",
      "Interface de operação intuitiva com medidor de energia em tempo real",
      "Leitor de cartão RFID para autenticação de usuários",
      "Monitoramento remoto via OCPP",
      "Proteção IP54 contra poeira e água",
    ],
    resumo: "Estação de recarga rápida DC de 60 a 480 kW, ideal para postos, empresas, shoppings e frotas.",
  },
];

export const SERVICES = [
  { titulo: "Carregadores rápidos DC", desc: "Estações de recarga em corrente contínua para operação comercial, frotas e eletropostos." },
  { titulo: "Projeto elétrico e dimensionamento", desc: "Estudo da infraestrutura existente e dimensionamento adequado a cada empreendimento." },
  { titulo: "Instalação e comissionamento", desc: "Execução, configuração e entrada em operação com equipe técnica especializada." },
  { titulo: "Plataforma de gerenciamento", desc: "Acompanhamento de estações, sessões, usuários e consumo em ambiente dedicado." },
  { titulo: "Monitoramento das estações", desc: "Supervisão contínua de status e disponibilidade dos carregadores." },
  { titulo: "Suporte técnico", desc: "Atendimento especializado para operação e manutenção da infraestrutura." },
];

export const SEGMENTS = [
  { titulo: "Postos de combustíveis e eletropostos", desc: "Recarga rápida como novo serviço e fonte de receita para o seu posto." },
  { titulo: "Empresas e frotas", desc: "Infraestrutura dedicada para eletrificação de frotas corporativas." },
  { titulo: "Supermercados e centros comerciais", desc: "Recarga enquanto o cliente compra: mais tempo de permanência e diferencial competitivo." },
  { titulo: "Hotéis e pousadas", desc: "Comodidade para hóspedes com veículos elétricos e posicionamento sustentável." },
  { titulo: "Estacionamentos", desc: "Monetização de vagas com recarga sob demanda." },
  { titulo: "Condomínios", desc: "Soluções compartilhadas ou individuais para moradores e visitantes." },
  { titulo: "Rodovias e pontos estratégicos", desc: "Corredores de recarga para viagens de longa distância." },
];

export const PROCESS_STEPS = [
  { titulo: "Análise da necessidade", desc: "Entendimento do perfil de uso, público e objetivos do empreendimento." },
  { titulo: "Levantamento da infraestrutura", desc: "Vistoria técnica do local: entrada de energia, transformadores, proteções e cabeamento." },
  { titulo: "Dimensionamento elétrico", desc: "Cálculo da capacidade disponível e definição da configuração adequada." },
  { titulo: "Projeto", desc: "Projeto elétrico e memorial técnico da instalação." },
  { titulo: "Instalação", desc: "Execução física por equipe técnica especializada." },
  { titulo: "Configuração", desc: "Parametrização dos carregadores e integração com a plataforma." },
  { titulo: "Comissionamento", desc: "Testes, validação e entrada oficial em operação." },
  { titulo: "Monitoramento e suporte", desc: "Acompanhamento contínuo e suporte técnico pós-instalação." },
];

export const PLATFORM_FEATURES = [
  { titulo: "Acompanhamento das estações", desc: "Visão geral de todas as estações em operação." },
  { titulo: "Status do carregador", desc: "Disponível, em uso, ocupado ou indisponível — em tempo real." },
  { titulo: "Sessões de recarga", desc: "Registro detalhado de cada sessão de carregamento." },
  { titulo: "Gestão de usuários", desc: "Cadastro e controle de usuários autorizados." },
  { titulo: "Histórico completo", desc: "Consulta ao histórico de operações e eventos." },
  { titulo: "Consumo de energia", desc: "Acompanhamento do consumo por estação e por período." },
  { titulo: "Relatórios", desc: "Relatórios gerenciais para tomada de decisão." },
  { titulo: "Gestão financeira", desc: "Cobrança e faturamento das recargas, quando aplicável ao modelo contratado." },
];

export const PLATFORM_COMMERCIAL = "Valores e condições comerciais da plataforma: em definição. Solicite uma proposta personalizada.";

export const RESPONSABILIDADES = [
  {
    titulo: "Fornecimento do equipamento",
    itens: [
      "A HB Solar é responsável pelo fornecimento dos carregadores conforme especificação comercial contratada.",
      "Prazos de entrega e condições comerciais são definidos em proposta específica para cada projeto.",
    ],
  },
  {
    titulo: "Projeto",
    itens: [
      "O projeto elétrico é desenvolvido com base no levantamento técnico realizado no local.",
      "A potência efetivamente disponível para carregamento depende da infraestrutura elétrica do local, demanda existente, capacidade de transformadores, proteções, cabos, fornecimento da concessionária e demais condições técnicas.",
      "Nenhuma potência de carregamento é garantida sem análise técnica prévia.",
    ],
  },
  {
    titulo: "Instalação",
    itens: [
      "A instalação segue o escopo definido em contrato, executada por equipe técnica qualificada.",
      "Adequações civis ou estruturais não previstas no escopo são de responsabilidade do cliente.",
    ],
  },
  {
    titulo: "Infraestrutura elétrica existente do cliente",
    itens: [
      "A infraestrutura elétrica existente (quadros, cabos, proteções e aterramento) deve atender às normas vigentes.",
      "Não conformidades identificadas no levantamento serão apontadas para correção pelo cliente antes ou durante o projeto.",
    ],
  },
  {
    titulo: "Disponibilidade de energia",
    itens: [
      "A disponibilidade e a continuidade do fornecimento de energia são de responsabilidade da concessionária local.",
      "A potência de recarga pode variar conforme as condições da rede elétrica em cada momento.",
    ],
  },
  {
    titulo: "Adequações elétricas",
    itens: [
      "Adequações como aumento de carga, troca de transformador ou reforço de cabeamento podem ser necessárias e serão apontadas no levantamento técnico.",
      "Quando não incluídas no escopo contratado, são de responsabilidade do cliente.",
    ],
  },
  {
    titulo: "Conexão com internet e rede",
    itens: [
      "O carregador depende de conectividade (rede local, Wi-Fi ou dados móveis) para recursos de gerenciamento remoto.",
      "O fornecimento e a qualidade do link de internet no local são de responsabilidade do cliente, salvo disposição em contrário no contrato.",
    ],
  },
  {
    titulo: "Concessionária de energia",
    itens: [
      "Solicitações de aumento de carga, vistorias e aprovações junto à concessionária seguem os prazos e critérios da própria concessionária.",
      "A HB Solar pode assessorar o cliente nesse processo, conforme escopo contratado.",
    ],
  },
  {
    titulo: "Operação",
    itens: [
      "A operação diária das estações (disponibilização, preços ao usuário final e atendimento ao motorista) é definida pelo modelo comercial contratado.",
    ],
  },
  {
    titulo: "Manutenção",
    itens: [
      "Planos de manutenção preventiva e corretiva são oferecidos conforme contrato de suporte.",
      "Danos por mau uso, vandalismo ou sinistros não se caracterizam como defeito do equipamento.",
    ],
  },
];

export const RESPONSABILIDADES_NOTA =
  "Este documento apresenta uma estrutura preliminar de responsabilidades, elaborada para fins de transparência comercial. Não constitui cláusula contratual ou jurídica definitiva e está sujeito a revisão jurídica e às condições específicas de cada contrato.";

// Textos e imagens principais editáveis pelo painel admin
export const DEFAULT_TEXTOS = {
  heroEvTitulo: "Infraestrutura inteligente para mobilidade elétrica",
  heroEvSubtitulo: "Soluções completas em carregamento de veículos elétricos, do projeto à operação.",
  homeServicosTitulo: "Solução completa, do projeto à operação",
  homeCtaTitulo: "Simule seu projeto de recarga",
  homeCtaTexto: "Informe os dados do seu estabelecimento e nossa engenharia retorna com a solução adequada para a sua infraestrutura.",
  solarTitulo: "Transforme o sol da Bahia em economia real",
  solarSubtitulo: "Reduza sua conta de luz em até 95% com um projeto sob medida — projeto, instalação e homologação junto à concessionária inclusos. Orçamento gratuito e sem compromisso.",
  gatewaySolarTitulo: "Energia Solar",
  gatewaySolarTexto: "Reduza sua conta de luz em até 95% com geração solar fotovoltaica — projeto, instalação e homologação completos.",
  gatewayChargerTitulo: "Carregadores para Veículos Elétricos",
  gatewayChargerTexto: "Infraestrutura inteligente para mobilidade elétrica — carregadores rápidos DC, projeto, instalação e plataforma de gerenciamento.",
};

export const DEFAULT_IMAGENS = {
  heroEv: "/hb-charger-estacao.png",
  solarHero: IMAGES.installation,
  gatewaySolar: IMAGES.hero,
  gatewayCharger: EV_IMAGES.hero,
};
